import savedSearchesRecentView from './savedSearchesRecentComponent.html';
import './savedSearchesRecentComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure';

export function savedSearchesRecentComponent() {
	return {
		bindings: {
			limit: '<',
			onFilter: '&',
		},
		controllerAs: 'vm',
		controller: savedSearchesRecentComponentCtrl,
		template: savedSearchesRecentView,
	};
}

export class savedSearchesRecentComponentCtrl {
	constructor(SavedSearches) {
		'ngInject';
		SavedSearches.onRecent(searches => {
			this.searches = ensure
				.array(searches)
				.slice(0, this.limit)
				.filter(recent => recent.criteria.label.length);
		});
	}

	performSearch(search) {
		this.onFilter({ $criteria: search.criteria });
	}
}
